"use client";

import { CloudSync } from "lucide-react";
import DriveIcon from "./DriveIcon";

type Props = {
  size?: number;
};

export const DriveSym = ({ size = 28 }: Props) => {
  const badgeSize = size * 0.40;

  return (
    <div className="relative inline-flex" style={{ width: size, height: size }}>
      <CloudSync   strokeWidth={1}  size={size} className="text-blue-600" />
      <div className="absolute -bottom-1 -right-1 rounded-full bg-white p-[2px]">
        <DriveIcon size={badgeSize}/>
      </div>
    </div>
 
  );
};
